import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import {
  routeFragment,
  ScanButtonComponent,
  SearchInputComponent,
} from '@softline/application';
import { ApiDataAccess } from '@softline/core';
import {
  IconComponent,
  InputComponent,
  LoadingSpinnerComponent,
  TabComponent,
  TabGroupComponent,
} from '@softline/ui-core';
import { SearchBarComponent } from '../../components/search-bar/search-bar.component';
import { BookmarkRepository } from '../../repository/bookmark.repository';
import { LastSearchBookmarkService } from '../../services/last-search-bookmark.service';
import { PageHeaderComponent } from '../page/page-header/page-header.component';
import { PageTabComponent } from '../page/page-tab/page-tab.component';
import { PageComponent } from '../page/page.component';

/*
export function provideLastSearchBookmarkService(params: BookmarkRepositoryParams) {
  const repositoryParamsToken = new InjectionToken<BookmarkRepositoryParams>(
    `BOOKMARK_REPOSITORY_PARAMS_${params.subCategory}`
  );

  const repositoryToken = new InjectionToken<BookmarkRepositoryParams>(
    `BOOKMARK_REPOSITORY_${params.subCategory}`
  );

  return [
    {
      provide: repositoryParamsToken,
      useValue: params,
    },
    {
      provide: repositoryToken,
      useFactory: () => new BookmarkRepository(inject(repositoryParamsToken)),
    },
    {
      provide: LastSearchBookmarkService,
      useFactory: () => new LastSearchBookmarkService(),
    },
  ];
}

searchPage = () => {
 const dataAccess = inject(DataAccess);
}
 */

export function searchPage(subCategory: string) {
  const dataAccess = inject(ApiDataAccess);
  //const bookmarkService = new LastSearchBookmarkService();

  return {
    subCategory,
    // bookmarkService,
  };
}

@Component({
  selector: 'soft-new-search-page',
  templateUrl: './new-search-page.component.html',
  styleUrls: ['./new-search-page.component.scss'],
  imports: [
    PageComponent,
    CommonModule,
    PageHeaderComponent,
    TabGroupComponent,
    TabComponent,
    InputComponent,
    IconComponent,
    PageTabComponent,
    LoadingSpinnerComponent,
    ScanButtonComponent,
    SearchInputComponent,
    SearchBarComponent,
  ],
  providers: [
    //TODO: Remove
    {
      provide: LastSearchBookmarkService,
      useFactory: () => new LastSearchBookmarkService(),
    },
    {
      provide: BookmarkRepository,
      useFactory: () =>
        new BookmarkRepository({ category: 'last-search', subCategory: 'product' }),
    },
  ],
})
// TODO:
export class NewSearchPageComponent {
  ref = input<ReturnType<typeof searchPage>>();
  bookmarkService = inject(LastSearchBookmarkService);

  lastSearchResults = computed(() => this.bookmarkService.all() ?? []);

  fragment = routeFragment();

  searchValue = signal<string | undefined>('');

  deleteAllLastSearchResults = (): void => {
    this.bookmarkService.deleteAll();
  };

  searchIt = (value) => {
    this.bookmarkService.search(value);
  };

  selectedTab = signal(1);

  selectTab(index: number): void {
    this.selectedTab.set(index);
  }
}
